import React from "react";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// MUI imports
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";

// Project imports
import FormStepper from "../../../Components/TrainingCentreRegistration/FormStepper";


const TrainingCentreRegistration = () => {
  const theme = useTheme();
  const largeScreen = useMediaQuery(theme.breakpoints.up('sm'))
  
  const styleClasses = {
    parentContainer: {
      marginTop: "100px",
      paddingBottom: "4rem",
      paddingLeft: largeScreen ? "80px" : "24px",
      paddingRight: largeScreen ? "80px" : "24px",
    },
    formContainer: {
      paddingTop: "20px",
    },
    stepperContainer: {
      marginTop: "24px"
    },
  };

  return (
    <>
      <CssBaseline />
      <Container style={styleClasses.parentContainer} maxWidth="lg" id="treg-container">
        <Box style={styleClasses.formContainer}>
        <h1>Training Centre Registration</h1>

          <Box style={styleClasses.stepperContainer}>
            <FormStepper />
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default TrainingCentreRegistration;
